import { MfaSendAlertProps } from '../../components/SmartErrorAlert';
import translate from '../translate';
import {
    mfaSendErrorFns,
    ErrState
} from './mfaSendErrors';
import { ErrorContentGenerator } from './getAlertContent';

export const mfaLoginGovDeliveryErrorFns = new ErrorContentGenerator<MfaSendAlertProps, 'field', ErrState>({
    apiErrorContent: {
        ...mfaSendErrorFns.apiErrorContent,
        govDelivery: {
            header: translate("we_couldnt_send_another_code"),
            body: mfaSendErrorFns.apiErrorContent.govDelivery.body,
            analyticsErr: "We can't send another security code right now. Try logging into your account later.If you need to access your account right now, call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048."
        },
    },
    invalidFieldMessages: mfaSendErrorFns.invalidFieldMessages,
    invalidFieldHeader: 'enter_the_six_digit_code',
    getRefMap: props => {
        return {
            field: props.fieldRef
        }
    },
    getErrState: mfaSendErrorFns.getErrState,
    getApiInvalidFields: mfaSendErrorFns.getApiInvalidFields,
    isIntermediateStep: false
});